import { apiService } from './index';

// Inport types
import { IParam } from '../shared/types/param';

export const asyncGetParam = async (
    type: 'CANALES' | 'TIPO_DOCUMENTO'
): Promise<IParam[]> => {
    return await apiService.get(`/api/param/${type}`);
};

export const asyncGetChannels = async (): Promise<IParam[]> => {
    return await asyncGetParam('CANALES');
};

export const asyncGetIdentification = async (): Promise<IParam[]> => {
    return await asyncGetParam('TIPO_DOCUMENTO');
};

export const asyncGetParamChannels = async (): Promise<IParam[]> => {
    return await apiService.get(`/api/param/channels`);
};
